import Overlay from './Overlay';

export default Overlay;
export { Overlay };
export type { OverlayProps } from './type';
